import { getClaimsDirectUrl } from 'wmic-portals-url-js';
import { ClaimsDirectService } from 'wmic-portals-transport-js';
import { DocumentUploadService } from '@xengage/gw-portals-document-js';

const ATTACHED_IN_ERROR_OUTCOME = 'attachedinerror';

function shouldExcludeClaimSummary(item = {}) {
    const closedOutcome = item.closedOutcome_WMIC;
    return typeof closedOutcome === 'string' && closedOutcome.toLowerCase() === ATTACHED_IN_ERROR_OUTCOME;
}

function filterClaimSummariesResponse(responseData = {}) {
    const safeResponseData = responseData && typeof responseData === 'object' ? responseData : {};
    const items = Array.isArray(safeResponseData.items) ? safeResponseData.items : [];
    return {
        ...safeResponseData,
        items: items.filter((item) => !shouldExcludeClaimSummary(item))
    };
}

export default class ClaimService {
    static getClaimSummaries(query, offset, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claim'), 'getClaimSummaries', [query, offset], additionalHeaders)
            .then(filterClaimSummariesResponse);
    }

    static getClaimDetail(claimNumber, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claim'), 'getClaimDetail', [claimNumber], additionalHeaders);
    }

    static getClaimPolicyDetail(claimNumber, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claim'), 'getClaimPolicyDetail', [claimNumber], additionalHeaders);
    }

    static getClaimActivities(claimNumber, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claim'), 'getClaimActivities', [claimNumber], additionalHeaders);
    }

    static getClaimNotes(claimNumber, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claim'), 'getClaimNotes', [claimNumber], additionalHeaders);
    }

    static createClaimNote(claimNumber, noteDTO, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claim'), 'createClaimNote', [claimNumber, noteDTO], additionalHeaders);
    }

    static updateClaimNote(claimNumber, note, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claim'), 'updateClaimNote', [claimNumber, note], additionalHeaders);
    }

    static deleteClaimNote(claimId, noteId, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claim'), 'deleteClaimNote', [claimId, noteId], additionalHeaders);
    }

    static uploadDocument(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(getClaimsDirectUrl('claimDocumentUpload'),
            file, documentMetadata, additionalHeaders);
    }

    static claimsDocUploadToken(params, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claimDocs'), 'generateUploadToken', params, additionalHeaders);
    }

    static claimsRemoveDocument(params, additionalHeaders = {}) {
        return ClaimsDirectService.send(getClaimsDirectUrl('claimDocs'), 'removeDocument', params, additionalHeaders);
    }
}
